import { adminBaseUrl, imageUrl, userBaseUrl, commonBaseUrl, otpUrl, cpBaseUrl } from "./baseUrl";
import axios from "axios";

const adminAxiosInstance = axios.create({
  baseURL: adminBaseUrl,
});

export const userAxiosInstance = axios.create({
  baseURL: userBaseUrl,
}); 

export const imageAxiosInstance = axios.create({
  baseURL: imageUrl
})
export const otpAxiosInstance = axios.create({
  baseURL: otpUrl
})
export const cpAxiosInstance = axios.create({
  baseURL: cpBaseUrl
})


export const commonAxiosInstance = axios.create({
  baseURL: commonBaseUrl,
});

// Attach Authorization header automatically from appropriate storage key
const attachAuthInterceptor = (instance, storageKey) => {
  if (!instance || !storageKey) return;
  instance.interceptors.request.use((config) => {
    try {
      const token = typeof window !== "undefined" ? localStorage.getItem(storageKey) : null;
      if (token) {
        config.headers = config.headers || {};
        config.headers["Authorization"] = `Bearer ${token}`;
      }
    } catch (e) {}
    return config;
  });
};

// Map tokens to instances
attachAuthInterceptor(adminAxiosInstance, "token");
attachAuthInterceptor(userAxiosInstance, "userToken");
attachAuthInterceptor(cpAxiosInstance, "cpToken");
// Some image endpoints may also require admin token
attachAuthInterceptor(imageAxiosInstance, "token");
// Typically public; skip attaching for OTP and common instances

export default adminAxiosInstance;
